<template>
  <div>
    <b-modal
      id="modal-brand-creator"
      centered
      hide-footer
      hide-header
      no-enforce-focus
      @hidden="clearEmail"
    >
      <ValidationObserver ref="form">
        <form @submit.prevent>
          <ValidationProvider
            v-slot="{ errors }"
            name="發送電郵邀請："
            rules="required|email"
            tag="div"
            ref="provider"
          >
            <div style="font-size: 13px;margin-bottom: 6px;">
              發送電郵邀請：
              <span v-if="errors.length > 0"
                style="color: #dc3545;"
              >
                請輸入有效的電郵地址
              </span>
            </div>
            <div class="input-group">
              <b-form-input
                v-model="receiver"
                type="text"
                :state="state(errors)"
                placeholder="電郵地址"
                :disabled="loading"
                autofocus
                required
              ></b-form-input>
              <div class="input-group-append send">
                <img
                  v-if="receiver.length == 0 || errors.length > 0"
                  src="../../assets/img/icon/icn-send.svg"
                  alt="Bootstrap" width="18" height="24"
                  z-index="999"
                  v-stream:click="onInputSubmit$">
                <img
                  v-else
                  src="../../assets/img/icon/icn-send-active.svg"
                  alt="Bootstrap" width="18" height="24"
                  z-index="999"
                  v-stream:click="onInputSubmit$">
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <LoadingSpinner v-if="loading"></LoadingSpinner>
    </b-modal>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import formMixin from '@/mixins/form';
import {
  BFormInput,
// BButton,
// BCol,
} from 'bootstrap-vue';
import {
  tap,
  switchMap,
} from 'rxjs/operators';
// import { getErrorMsg } from '@/helpers/error-msg';
// import toastSettings from '@/helpers/toast-settings';
import { ValidationProvider } from 'vee-validate';

export default {
  mixins: [formMixin],
  components: {
    // AGCTextarea,
    // BButton,
    // BCol,
    LoadingSpinner,
    BFormInput,
    ValidationProvider,
  },

  data: () => ({
    receiver: '',
    loading: false,
  }),
  computed: {
    state() {
      return (errors) => {
        if (errors.length > 0) return false;
        return null;
      };
    },
  },
  methods: {
    emitEmail() {
      this.$emit('sendbtn', this.receiver);
      this.clearEmail();
    },
    clearEmail() {
      this.receiver = '';
    },
  },

  domStreams: ['onInputSubmit$'],
  subscriptions() {
    return {
      inputSubmit: this.onInputSubmit$.pipe(
        switchMap(this.validate),
        tap(() => {
          this.emitEmail();
          this.$bvModal.hide('modal-brand-creator');
          // this.loading = true;
        }),
      ),
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .modal{
    &-dialog {
      max-width: 700px;
    }

    &-content {
      border-radius: 12px;
      background-color: rgb(242, 244, 246);
    }

    &-title {
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: #3a4047;
    }

    &-body {
        padding: 16px;
    }

    &-body .col-12 {
      padding: 0;
      text-align: right;
    }
  }

  .action {
    text-align: right;
    width: 100%;
    padding: 0px 15px;
    button {
      width: 114px;
      height: 42px;
      display: inline-block;
      margin-left: 15px;
    }
  }
  .input-box{
    width: 100%;
  }
  .input-group{
    display: inline-block;
    .form-control{
      width: 100%;
      background-image: none;
      border-radius: 8px;
    }
  }

  .send{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;

  }

}
</style>
